import * as client from '@dashhudson/api-client/snapchat/client';

export const getSnapchatProfile = ({ brandId }: { brandId: number }, config: RequestInit = {}) =>
  client.getBrandsBrandIdProfile(brandId, config);

export const getSnapchatProfileAllBrands = (
  { brandIds }: { brandIds: number[] },
  config: RequestInit = {},
) => client.putBrandProfiles({ brandIds }, config);
